import { render, staticRenderFns } from "./TasksProgressIndicator.vue?vue&type=template&id=227538b2"
import script from "./TasksProgressIndicator.vue?vue&type=script&lang=ts"
export * from "./TasksProgressIndicator.vue?vue&type=script&lang=ts"
import style0 from "./TasksProgressIndicator.vue?vue&type=style&index=0&id=227538b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports